import { render, staticRenderFns } from "./messageTemplates.vue?vue&type=template&id=3e033cf9&"
import script from "./messageTemplates.vue?vue&type=script&lang=js&"
export * from "./messageTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports